var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"control"},[_c('button',{staticClass:"button px-2",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('orient-north')}}},[_c('inline-svg',{attrs:{"id":"compasscomp","type":"image/svg+xml","src":require('@/assets/compass.svg'),"width":"24","height":"24"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }